/*
Author: Chathuraka Mallawa Arachchi
Date: 25/01/2025
Copyright © 2024 Infix!. All rights reserved.
*/

import {Utility} from "@/utils";
import React,{ReactNode,useEffect,useState} from "react";
import {INode} from "../SurveyModel/types/nodeTypes";

interface IQuestionSet {
    node: INode
    children:ReactNode
}

const QuestionSet = (props:IQuestionSet) => {
     const {children, node} = props
     const [classes, setClasses] = useState('') 

     useEffect(() => {
      const rawConfigClasses = Utility.getValueFromKey(node, 'CssClasses');
      
      try {
        const parsed = rawConfigClasses ? JSON.parse(rawConfigClasses) : [];
    
        if (Array.isArray(parsed)) {
          const result = parsed.join(' ');
          setClasses(result);
        }
      } catch (e) {
        console.error('Invalid JSON in CssClasses:', rawConfigClasses);
        setClasses('');
      }
    }, [node]);

         return ( <React.Fragment>
            <div className={`question-set-wrapper input-border-top ${classes ? classes : ''}`}>
              {node.title ? <div className="question-set-title">{node.title}</div> : null}
                {children}           
             </div> 
            
        </React.Fragment>
     
        )
    
}

export default QuestionSet;